export default [
  {
    path: '/organization/guide-tutorial/list',
    name: 'organization-guide-tutorial-list',
    component: () => import('@/views/organization/guide-tutorial/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Guide Tutorial List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Guide Tutorial' }, { title: 'Guide Tutorial List', active: true }],
      permissions: ['guide_tutorial_list']
    }
  }
]
